import React, {PropTypes} from 'react';
import Card from './components/Card';
import axios from 'axios';

class Announcement extends React.Component {

    constructor(props) {
      super(props);
      this.state={data: null}
    }
    componentDidMount()
    {
      console.log(this.props.params.id);
      axios.get(process.env.REQ_URL +"/chatter/getAnnouncementById?q="+this.props.params.id,{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=>{
        this.setState({data: response.data.data})
      }).catch((error)=>{

      });
    }
    render() {
        return (
          <div>
            {this.state.data==null?"This Announcement has been deleted":<Card
            data ={this.state.data}
            employee={this.props.employee}/>}

          </div>
        );
    }
}

Announcement.propTypes = {};

export default Announcement;





/** WEBPACK FOOTER **
 ** ./src/feature/announcements/Announcement.js
 **/